module.exports = __webpack_public_path__ + "static/media/E84E21C6-6C2D-42BD-8DF9-D215368E927F.c82a4d29.JPG";